import React from 'react';
import Spinner from './Spinner.js';
import '../../css/SiteLoading.css';

const FeaturesLoading = () => {
    return (
        <div className="siteLoadingContainer">
            <div className="siteLoadingContent">
                <div className="siteLoadingLogo">
                    <img src="/minute7-logo.png" alt="Minute7" className="siteLoadingLogoImage" />
                </div>
                <div className="siteLoadingSpinner">
                    <Spinner />
                </div>
            </div>
        </div>
    );
};

export default FeaturesLoading;
